import { extensions } from '../../extensions/Extensions';
import { CanvasTextPipe } from './canvas/CanvasTextPipe';
import { CanvasTextSystem } from './canvas/CanvasTextSystem';

extensions.add(CanvasTextSystem);
extensions.add(CanvasTextPipe);
